export const REACT_APP_BASE_URL = "https://api.mookh.com";
export const NODE_ENV = "development";



// WEBPACK FOOTER //
// ./src/constants.js